import { render, staticRenderFns } from "./ClientesList.vue?vue&type=template&id=8378a974"
import script from "./ClientesList.vue?vue&type=script&lang=js"
export * from "./ClientesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports